import * as React from 'react';
import type { ProjectId } from 'owa-timestream-types';
import initializeTasks from '../utils/initializeTasks';

export default function useInitializeTasks(projectId: ProjectId) {
    React.useEffect(() => {
        initializeTasks(projectId);
    }, [projectId]);
}
